/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type TransitionCaseCommand = {
    caseId?: string;
    reason?: string;
    toStatus?: TransitionCaseCommand.toStatus;
};
export namespace TransitionCaseCommand {
    export enum toStatus {
        PENDING = 'PENDING',
        APPROVED = 'APPROVED',
        ARCHIVED = 'ARCHIVED',
        REJECTED = 'REJECTED',
        CLOSED = 'CLOSED',
    }
}

